import React from "react";
import styles from "./ProfileData.module.css";

import LoadingOverlay from "react-loading-overlay";
const ProfileData = ({ profileData }) => {
  const [loading, setLoading] = React.useState(false);
  return (
    <>
      <div className={styles.ProfileData}>
        <div>
          {profileData ? (
            <div className={styles.ProfileDataBox}>
              <div>
                <h3>Date Of Birth:</h3>
                <p>{profileData.dob}</p>
              </div>
              <div>
                <h3>Name</h3>
                <p>{profileData.name}</p>
              </div>
              <div>
                <h3>Email:</h3>
                <p>{profileData.email}</p>
              </div>
              <div>
                <h3>Parent Email:</h3>
                <p>{profileData.parent_mail}</p>
              </div>
              <div>
                <h3>Parent Name:</h3>
                <p>{profileData.parent_name}</p>
              </div>
              <div>
                <h3>Mobile number:</h3>
                <p>{profileData.student_phone}</p>
              </div>
              <div>
                <h3>Student Code:</h3>
                <p>{profileData.self_filled_student_code}</p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ProfileData;
